import React from "react";
import {
  FaSearch,
  FaProjectDiagram,
  FaLaptopCode,
  FaLink,
  FaCogs,
  FaUserShield,
  FaServer,
  FaCoins,
  FaLock,
  FaHeadset,
  FaChartLine,
  FaPencilRuler,
  FaTachometerAlt,
  FaSync,
  FaRegChartBar,
  FaBug,
  FaTrophy,
  FaBrain,
  FaUsers,
  FaLightbulb,
} from "react-icons/fa";

const Section = ({ title, items }) => (
  <div className="premium-section">
    <h3>{title}</h3>

    {items.map((item, i) => (
      <div className="premium-item" key={i}>
        <div className="premium-icon">{item.icon}</div>
        <div>
          <h6>{item.title}</h6>
          <p>{item.desc}</p>
        </div>
      </div>
    ))}
  </div>
);

export default function HederaHashgraph() {
  return (
    <section className="hedera-premium">
      <div className="container">
        {/* HEADER */}
        <div className="premium-header">
          <span>WHAT WE OFFER</span>
          <h2>
            Services Offered in <br />
            Hedera Hashgraph Development
          </h2>
          <p>
            Scalable, secure, and production-ready blockchain solutions built
            with modern architecture and real-world performance.
          </p>
        </div>

        {/* GRID */}
        <div className="premium-grid">
          <Section
            title="Custom dApp Development"
            items={[
              {
                icon: <FaSearch />,
                title: "Requirement Analysis",
                desc: "Deep understanding of business needs.",
              },
              {
                icon: <FaProjectDiagram />,
                title: "Architecture Design",
                desc: "Secure scalable architecture.",
              },
              {
                icon: <FaLaptopCode />,
                title: "Full Stack Dev",
                desc: "Frontend + backend systems.",
              },
              {
                icon: <FaLink />,
                title: "Integration",
                desc: "Seamless infrastructure connection.",
              },
            ]}
          />

          <Section
            title="Smart Contract Development"
            items={[
              {
                icon: <FaCogs />,
                title: "Design & Build",
                desc: "Robust smart contracts.",
              },
              {
                icon: <FaUserShield />,
                title: "Security Audit",
                desc: "Vulnerability detection.",
              },
              {
                icon: <FaServer />,
                title: "Deployment",
                desc: "Stable production launch.",
              },
            ]}
          />

          <Section
            title="Token Development"
            items={[
              {
                icon: <FaCoins />,
                title: "Utility Tokens",
                desc: "Enable ecosystem transactions.",
              },
              {
                icon: <FaLock />,
                title: "Security Tokens",
                desc: "Regulated fundraising tokens.",
              },
              {
                icon: <FaHeadset />,
                title: "Support",
                desc: "Complete lifecycle support.",
              },
            ]}
          />

          <Section
            title="Hedera Consulting"
            items={[
              {
                icon: <FaChartLine />,
                title: "Assessment",
                desc: "Identify best use-case.",
              },
              {
                icon: <FaPencilRuler />,
                title: "Architecture",
                desc: "Efficient system design.",
              },
              {
                icon: <FaTachometerAlt />,
                title: "Optimization",
                desc: "Boost performance.",
              },
            ]}
          />

          <Section
            title="Migration Services"
            items={[
              {
                icon: <FaSync />,
                title: "Upgrade Systems",
                desc: "Stay updated with tech.",
              },
              {
                icon: <FaRegChartBar />,
                title: "Monitoring",
                desc: "Track system performance.",
              },
              {
                icon: <FaBug />,
                title: "Bug Fixing",
                desc: "Fast issue resolution.",
              },
            ]}
          />

          <Section
            title="Why Choose Xeer"
            items={[
              {
                icon: <FaTrophy />,
                title: "Proven Work",
                desc: "Successful delivery record.",
              },
              {
                icon: <FaBrain />,
                title: "Expert Team",
                desc: "Blockchain specialists.",
              },
              {
                icon: <FaUsers />,
                title: "Client Focus",
                desc: "User-first mindset.",
              },
              {
                icon: <FaLightbulb />,
                title: "Innovation",
                desc: "Future-ready solutions.",
              },
            ]}
          />
        </div>
      </div>
    </section>
  );
}
